import { Alert, Button } from "@filadd/phi-plus-core";
import { css } from "@filadd/phi-plus-styled-system/css";
import { useAuth } from "AuthContext";
import { useCourseInfo } from "hooks/course";
import { useLaplaceAccess } from "hooks/laplace";

const LAPLACE_DEFAULT_URL = "https://filadd.com.br/#nossos-cursos";

interface Props {
  courseSlug: string;
  buttonText: string;
  descriptionText: string;
}

export const LaplaceAccessButton = ({
  courseSlug,
  buttonText,
  descriptionText,
}: Props) => {
  const { user } = useAuth();
  const courseInfoQuery = useCourseInfo({ courseSlug });

  const currentRelease = user?.releases?.find(
    (release) => release.course.slug === courseInfoQuery.data?.slug,
  );
  const laplaceAccessUrlQuery = useLaplaceAccess({
    userId: user?.id,
    select: (laplaceAccess) =>
      currentRelease == null ? LAPLACE_DEFAULT_URL : laplaceAccess.sso,
  });

  return (
    <div
      className={css({
        p: { base: 0, lg: 4 },
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 2,
      })}
    >
      <p className={css({ textAlign: "center" })}>{descriptionText}</p>
      <Button asChild disabled={laplaceAccessUrlQuery.data == null}>
        <a href={laplaceAccessUrlQuery.data} target="_blank" rel="noreferrer">
          {buttonText}
        </a>
      </Button>
      {laplaceAccessUrlQuery.data == null && (
        <Alert type="warning" className={css({ mt: 2 })}>
          Seu acesso ainda não foi habilitado pelo Laplace. Esse processo pode
          levar de alguns minutos até uma hora. Por favor, tente novamente mais
          tarde
        </Alert>
      )}
    </div>
  );
};
